var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn btn-primary waves-effect waves-themed shadow-0",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.makeExcel.apply(null, arguments)
        },
      },
    },
    [_c("span", [_vm._v("XLS")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }